"use strict";
// WCAG 2.1 relative luminance and contrast ratio.
// Lives in commons so the locked-surface palettes can be asserted in CI rather
// than discovered on a device.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AA_LARGE_TEXT = exports.AA_NORMAL_TEXT = exports.contrastRatio = exports.relativeLuminance = void 0;
const expand = (hex) => {
    const value = hex.replace("#", "");
    if (value.length === 3) {
        return value
            .split("")
            .map(c => c + c)
            .join("");
    }
    return value.slice(0, 6);
};
// The theme stores some colours as `rgb(…)` strings rather than hex, so both
// spellings have to parse or the budget silently returns NaN and every assertion
// passes vacuously.
const channels = (colour) => {
    const rgb = colour.match(/rgba?\(([^)]+)\)/i);
    if (rgb) {
        const parts = rgb[1].split(",").map(part => Number(part.trim()));
        return [parts[0], parts[1], parts[2]];
    }
    const full = expand(colour);
    return [0, 2, 4].map(offset => parseInt(full.slice(offset, offset + 2), 16));
};
const relativeLuminance = (hex) => {
    const [r, g, b] = channels(hex).map(value => {
        const channel = value / 255;
        return channel <= 0.03928
            ? channel / 12.92
            : Math.pow(((channel + 0.055) / 1.055), 2.4);
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
exports.relativeLuminance = relativeLuminance;
const contrastRatio = (foreground, background) => {
    const a = (0, exports.relativeLuminance)(foreground);
    const b = (0, exports.relativeLuminance)(background);
    const lighter = Math.max(a, b);
    const darker = Math.min(a, b);
    return (lighter + 0.05) / (darker + 0.05);
};
exports.contrastRatio = contrastRatio;
exports.AA_NORMAL_TEXT = 4.5;
exports.AA_LARGE_TEXT = 3;
